import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { LoadingService } from './../../shared/services/loading.service';

import {
  IPaginationValue,
  PaginationComponent,
} from '../../shared/components/pagination/pagination.component';
import { TableComponent } from '../../shared/components/table/table.component';
import { HomeService } from '../../shared/services/home.service';
import { IHome } from '../../utils/interfaces/home';
import { ITableHeader } from '../../utils/interfaces/table-header';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TableComponent,
    PaginationComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit, OnDestroy {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly homeService = inject(HomeService);
  private readonly loadingService = inject(LoadingService);
  private readonly unsubscribe$ = new Subject();

  count = 0;
  pagination: IPaginationValue = {
    page: 1,
    take: 10,
  };

  searchUser = new FormControl('');

  tableHeader: ITableHeader[] = [
    {
      description: 'Status',
      propertyKey: 'status',
      status: false,
      date: false,
      actions: false,
      filter: false,
      showHour: false,
      borderColor: true,
    },
    {
      description: 'Dispositivos',
      propertyKey: 'device',
      status: false,
      date: false,
      actions: false,
      filter: false,
      showHour: false,
    },
    {
      description: 'Cliente',
      propertyKey: 'customerName',
      status: false,
      date: false,
      actions: false,
      filter: false,
      showHour: false,
    },
    {
      description: 'Última atualização',
      propertyKey: 'lastConnection',
      status: false,
      date: true,
      actions: false,
      filter: false,
      showHour: true,
    },
    {
      description: 'Pesquisa atual',
      propertyKey: 'currentPoll',
      status: false,
      date: false,
      actions: false,
      filter: false,
      showHour: false,
    },
    {
      description: 'Data de ativação',
      propertyKey: 'activationDate',
      status: false,
      date: true,
      actions: false,
      filter: false,
      showHour: false,
    },
    {
      description: 'Ações',
      propertyKey: '',
      status: false,
      date: false,
      actions: true,
      filter: false,
      showHour: false,
    },
  ];

  data: IHome[] = [];

  ngOnInit(): void {
    const { count, data } = this.activatedRoute.snapshot.data['home'];
    this.data = data;
    this.count = count ?? 0;

    this.searchUser.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .pipe(debounceTime(700))
      .subscribe(() => this.getDevices(true));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  onPaginationChange(event: IPaginationValue): void {
    this.pagination = event;

    this.getDevices();
  }

  getDevices(search = false): void {
    this.loadingService.showLoading();
    this.homeService
      .getDataHome(
        search,
        this.searchUser.value ?? '',
        this.pagination.page,
        this.pagination.take
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response) => {
          this.data = response.data;
          this.count = response.count ?? 0;

          if (search) {
            this.pagination.page = 1;
          }

          this.loadingService.closeLoading();
        },
      });
  }

  selectAction(event: { id: string; func: string }): void {
    this.router.navigate([`main/home/device/${event.id}`]);
  }
}
